import { Button, Modal } from 'lego-on-react';
import React, { FC, useEffect, useState } from 'react';

import block from 'propmods';

import { newsSubscribe } from '../../api';
import { shouldShowAnnouncement, updateAnnouncementState } from '../../lib/announcement';
import { spamAgreenemt } from '../../lib/gdpr-texts';
import { H2 } from '../Typo/Typo';

import './Announcement.scss';
const b = block('Announcement');
import { routes } from '../../lib/routes';

const Announcement: FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    const onShow = () => {
        setIsVisible(true);
        updateAnnouncementState();
    };
    const onClose = () => {
        setIsVisible(false);
        updateAnnouncementState();
    };
    const onSubscribeClick = async () => {
        await newsSubscribe();
        onClose();
    };
    useEffect(() => {
        if (shouldShowAnnouncement()) {
            onShow();
        }
    }, []);

    return (
        <Modal visible={isVisible} onOutsideClick={onClose}>
            <div {...b('wrap')}>
                <div {...b('header')}>
                    <H2 {...b('title')}>Подпишитесь на новостную рассылку</H2>
                </div>
                <div {...b('body')}>
                    Подпишитесь на Глобальные сообщения и новости сервисов! <br />
                    Мы будем сообщать вам только о самых важных изменениях и новостях работы платформы.
                    <img src={routes.app.assets('images/mail.png')} {...b('img')} />
                </div>
                <div {...b('constrols')}>
                    <Button onClick={onSubscribeClick} theme="action" size="s">
                        Подписаться
                    </Button>
                    <Button onClick={onClose} theme="normal" size="s">
                        Закрыть
                    </Button>
                </div>
                <div {...b('description')}>{spamAgreenemt}</div>
            </div>
        </Modal>
    );
};

export default Announcement;
